const Wishlist = {

    // FIELDS
    "search": "Search",

    // PAGE HEADER
    "wishlist": "Wishlist",

    // TABLE HEADER
    "table_user": "USER",
    "table_email": "EMAIL",
    "table_mobile": "MOBILE",
    "table_product": "PRODUCT",
    "table_variant": "VARIANT",
    "table_added_on": "ADDED ON",

}

export default Wishlist;